import { CSSObject } from '@emotion/react';

export const rows: CSSObject = {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px 0',
};

export const row: CSSObject = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: '0 16px',
  fontSize: '14px',
};

export const label: CSSObject = {
  width: '180px',
  flexShrink: 0,
  fontWeight: 600,
  color: '#5f6069',
};

export const buttons: CSSObject = {
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '0 8px',
  marginTop: '16px',
};

export const note: CSSObject = {
  marginTop: '12px',
  fontSize: '12px',
  color: 'gray',
};
